import React, { Fragment } from "react";
import { Col, Row } from "antd";
import DimensionValue from "./DimensionValue";
import DimensionLabel from "./DimensionLabel";
import Arrow from "../../../components/GraphViews/Arrow";
import { toUnit } from "../../../summary/format";

const Diff = props => {
  const trend = props.trend || 0;
  let valueToDisplay = props.valueStr;
  if (!props.format && props.unit) {
    valueToDisplay = toUnit(props.value, props.unit);
  }

  return (
    <Fragment>
      {typeof props.value === "number" && (
        <span
          style={{
            display: "flex",
            flexDirection: props.span === 3 ? "row" : "column",
            justifyContent: props.span === 3 ? "space-around" : undefined,
            alignItems: props.span === 3 ? undefined : "center"
          }}
        >
          {valueToDisplay}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Arrow size={"xs"} trend={trend}></Arrow>
          </div>
        </span>
      )}
    </Fragment>
  );
};
export const computeColSpans = (fullWidth, isComparing, labelsLength) => {
  let colValue = 18;
  let colRatio = 10;
  let colProgressBar = 13;
  let colDiff = isComparing ? 3 : 0;
  if (isComparing) {
    if (labelsLength === 4) {
      colValue = 5;
      colDiff = 2;
    } else if (labelsLength === 3) {
      colValue = 5;
      colDiff = 2;
    } else if (labelsLength === 2) {
      colValue = 6;
    } else {
      colValue = 8;
    }
  } else {
    if (labelsLength === 4) {
      colValue = 8;
    } else if (labelsLength === 3) {
      colValue = 9;
    } else if (labelsLength === 2) {
      colValue = 12;
      colProgressBar = 17;
      colRatio = 6;
    } else if (labelsLength === 1) {
      colProgressBar = 17;
      colRatio = 6;
    }
  }

  let colTitle = Math.floor((24 - (colValue + (colDiff + colValue) * isComparing)) / labelsLength);

  if (colTitle > 6) colTitle = 6;

  if (fullWidth) {
    colTitle = 24 / (labelsLength + 1);
    colValue = 24 / (labelsLength + 1);

    //hacks
    //TODO custom dim
    if (labelsLength + 1 === 2) {
      colTitle = 8;
      colValue = 16;
    }
  }

  return { colTitle, colValue, colDiff, colProgressBar, colRatio };
};
const Dimension = props => {
  const { labels = [], value = {}, isComparing, fullWidth } = props;
  const { colTitle, colDiff, colValue, colProgressBar, colRatio } = computeColSpans(
    fullWidth,
    isComparing,
    labels.length
  );
  let progressColor = "#60a2ff";
  if (labels[labels.length - 1] === "Total") {
    progressColor = "#182ba9";
  }

  return (
    <Row gutter={16} style={{ marginTop: 20 }}>
      {labels.map(label => (
        <Col span={colTitle}>
          <DimensionLabel label={label} />
        </Col>
      ))}
      <Col span={colValue}>
        <DimensionValue
          {...value}
          progressColor={progressColor}
          indexGraph={props.indexGraph}
          progressBarDelay={props.progressBarDelay}
          colRatio={colRatio}
          colProgressBar={colProgressBar}
        />
      </Col>
      {isComparing && (
        <Fragment>
          <Col span={colValue}>
            <DimensionValue
              {...value.p1}
              progressColor={progressColor}
              indexGraph={props.indexGraph}
              progressBarDelay={props.progressBarDelay}
              colRatio={colRatio}
              colProgressBar={colProgressBar}
            />
          </Col>
          <Col span={colDiff}>
            <Diff {...value.diff} span={colDiff} />
          </Col>
        </Fragment>
      )}
    </Row>
  );
};

export default Dimension;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Dimension/Dimension.js